/* eslint-disable @typescript-eslint/no-unused-vars */
import { FunctionComponent, useState } from 'react';
import styles from './contactsales.module.css';
import { toast } from 'react-toastify';
import { ClipLoader, MoonLoader } from 'react-spinners';
import 'react-toastify/dist/ReactToastify.css';
import {useMediaQuery} from "@mui/material";
const ContactSales: FunctionComponent = () => {
    const [fullName, setFullName] = useState("");
    const [emaiAddress, setMailAddress] = useState("");
    const [phoneno, setPhoneno] = useState("");
    const [loading, setLoading] = useState(false);
    const validatePhoneNumber = (phone: string) => {
        const phoneRegex = /^[0-9]{10}$/;
        return phoneRegex.test(phone);
    };

    // Email validation using regex
    const validateEmail = (email: string) => {
        const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
        return emailRegex.test(email);
    };
    const handleSubmit = async () => {
        if (!fullName || !emaiAddress || !phoneno) {
            toast.error("All fields are required!");
            return;
        }
        if (!validatePhoneNumber(phoneno)) {
            toast.error("Phone number must be 10 digits and contain only numbers.");
            return;
        }

        // Validate email address
        if (!validateEmail(emaiAddress)) {
            toast.error("Please enter a valid email address.");
            return;
        }
        setLoading(true);
        try {
            const formData = new URLSearchParams();
            formData.append("fullName", fullName);
            formData.append("emaiAddress", emaiAddress);
            formData.append("phoneno", phoneno);


            const response = await fetch("https://script.google.com/macros/s/AKfycbwT6lleixKO4vN4wmsqhX-MoC_us4S_UORv52J6Il4Ma5kD_Mg8SM5WCkAzCVL-JUuT/exec", {
                method: "POST",
                body: formData,
            });

            const result = await response.json();
            toast.success(result.message || "Form submitted successfully!");
        } catch (error) {
            setLoading(false);
            toast.error("Failed to submit. Please try again.");
        } finally {
            setLoading(false);
            setFullName("");
            setMailAddress("");
            setPhoneno("");
        }
    };

    const isMobile = useMediaQuery("(max-width: 768px)");


    return (
        <center>
            <div style={{ paddingTop: "12rem" }}>
                <div className={styles.headingSales} >Get in touch with us!</div>
                <div className={styles.smallerText}>Connect with our team to find smarter solutions for debt recovery, enhancing efficiency, optimizing strategies, and maintaining trust while fostering strong customer relationships.</div>
                {isMobile && (
                    <>
                        <div className={styles.frameParent2} >
                        <div className={styles.frameGroup}>
                            <div className={styles.frameGroup}>
                                {/*<div className={styles.groupParent}>*/}
                                <div style={{width: "92%", textAlign: "left"}}>
                                    <label
                                        style={{
                                            fontWeight: "500",
                                            display: "block",
                                            color: "white",
                                            fontSize: "14px",
                                            marginTop: "20px",
                                        }}
                                    >
                                        Full Name*
                                    </label>
                                </div>

                                <div style={{position: "relative", width: "100%"}}>
                                    <input
                                        value={fullName}
                                        onChange={(e) => setFullName(e.target.value)}
                                        placeholder="John Carter"
                                        style={{
                                            width: "100%", // full width of parent container
                                            paddingLeft: "10px",
                                            paddingRight: "40px", // space for the icon
                                            height: "50px",
                                            borderRadius: "10px",
                                            marginTop: "-30px",
                                            fontSize: "16px",
                                            color: "black",
                                            border: "1px solid #ccc",
                                            outline: "none",
                                            boxSizing: "border-box"
                                        }}
                                    />

                                    <img
                                        src="./assets/usericon.svg"
                                        alt="User Icon"
                                        style={{
                                            position: "absolute",
                                            right: "30px",
                                            top: "30%",
                                            transform: "translateY(-50%)",
                                            height: "22px",
                                            width: "24px",
                                            pointerEvents: "none"
                                        }}
                                    />
                                </div>


                                {/*</div>*/}
                                <div style={{width: "92%", textAlign: "left"}}>
                                    <label style={{
                                        fontWeight: "500",
                                       // marginBottom: "1px",
                                        display: "block",
                                        color: "white",
                                        fontSize: "14px",
                                        // marginTop: "5px"
                                    }}>
                                        Phone Number*
                                    </label>
                                </div>
                                <div style={{position: "relative", width: "100%"}}>
                                    <input
                                        value={phoneno}
                                        onChange={(e) => setPhoneno(e.target.value)}
                                        placeholder="9876543210"
                                        style={{
                                            width: "100%", // full width of parent container
                                            paddingLeft: "10px",
                                            paddingRight: "40px", // space for the icon
                                            height: "50px",
                                            borderRadius: "10px",
                                            marginTop: "-30px",
                                            fontSize: "16px",
                                            color: "black",
                                            border: "1px solid #ccc",
                                            outline: "none",
                                            boxSizing: "border-box"
                                        }}
                                    />

                                    <img
                                        src="./assets/phoneno.svg"
                                        alt="User Icon"
                                        style={{
                                            position: "absolute",
                                            right: "30px",
                                            top: "30%",
                                            transform: "translateY(-50%)",
                                            height: "22px",
                                            width: "24px",
                                            pointerEvents: "none"
                                        }}
                                    />
                                </div>
                                <div style={{width: "92%", textAlign: "left"}}>
                                    <label style={{
                                        fontWeight: "500",
                                       // marginBottom: "10px",
                                        display: "block",
                                        color: "white",
                                        fontSize: "14px",
                                      //  marginTop: "2px"
                                    }}>
                                        Email Address*
                                    </label>
                                </div>
                                <div style={{position: "relative", width: "100%"}}>
                                    <input
                                        value={emaiAddress}
                                        onChange={(e) => setMailAddress(e.target.value)}
                                        placeholder="Email Address"
                                        style={{
                                            width: "96%",
                                            paddingLeft: "10px",
                                            height: "50px",
                                            borderRadius: "10px",
                                            zIndex: 1000,
                                            marginTop: "-30px",
                                            fontSize: "16px",
                                            color: "black",
                                            border: "1px solid #ccc", // Light grey border
                                            outline: "none",
                                        }}
                                    />
                                    <img
                                        src="./assets/email.svg"
                                        alt="User Icon"
                                        style={{
                                            position: "absolute",
                                            right: "30px",
                                            top: "5%",
                                            transform: "translateY(-50%)",
                                            height: "24px",
                                            width: "20px",
                                            pointerEvents: "none", // prevents image from blocking input clicks
                                        }}
                                    />
                                    <div className={styles.primaryBtn} onClick={handleSubmit}>
                                        <div
                                            className={styles.buttonText}
                                            style={{
                                                cursor: "pointer",
                                                display: "flex",
                                                alignItems: "center",
                                                gap: "8px", // space between text and icon
                                            }}
                                        >
                                            Submit
                                            <img
                                                src="./assets/rightarrow.svg" // update the path to your icon
                                                alt="Submit Icon"
                                                style={{
                                                    height: "20px",
                                                    width: "20px",
                                                }}
                                            />
                                        </div>

                                        <img className={styles.arrowRightIcon} alt="" src="./assets/arrow.png"/>
                                    </div>
                                </div>

                            </div>
                        </div>

                         <div className={styles.seeHowCredresolveHelpsYouParent}>
                                    <div className={styles.seeHowCredresolve}>See how CredResolve helps you get industry
                                        leading
                                        recovery rates
                                    </div>
                                    <div className={styles.borderParent}>
                                        <div className={styles.border}/>
                                        <div className={styles.border1}/>
                                        <div className={styles.border2}/>
                                        <img className={styles.component2Icon} alt="" src="./assets/collection1.png"/>
                                        <div className={styles.gainRealTimeInsights}>Gain real-time insights into
                                            collections with
                                            AI-powered dashboards for accuracy and efficiency.
                                        </div>
                                        <img className={styles.component3Icon} alt="" src="./assets/collection2.png"/>
                                        <div className={styles.trackEveryStage1}>Track every stage optimizing
                                            performance and
                                            maximizing profitability with intelligent analytics.
                                        </div>
                                        <img className={styles.component4Icon} alt="" src="./assets/collection3.png"/>
                                        <div className={styles.enhanceDecisionMakingWith}>Enhance decision-making with
                                            precision-driven AI tools for data-backed collection processes.
                                        </div>
                                    </div>
                                </div>

                        </div>
                    </>


                )}

                {!isMobile && (
                    <>
                        <div
                            className={styles.frameParent}
                        >
                            <div className={styles.seeHowCredresolveHelpsYouParent}>
                                <div className={styles.seeHowCredresolve}>See how CredResolve helps you get industry
                                    leading
                                    recovery rates
                                </div>
                                <div className={styles.borderParent}>
                                    <div className={styles.border}/>
                                    <div className={styles.border1}/>
                                    <div className={styles.border2}/>
                                    <img className={styles.component2Icon} alt="" src="./assets/collection1.png"/>
                                    <div className={styles.gainRealTimeInsights}>Gain real-time insights into
                                        collections with
                                        AI-powered dashboards for accuracy and efficiency.
                                    </div>
                                    <img className={styles.component3Icon} alt="" src="./assets/collection2.png"/>
                                    <div className={styles.trackEveryStage}>Track every stage optimizing performance and
                                        maximizing profitability with intelligent analytics.
                                    </div>
                                    <img className={styles.component4Icon} alt="" src="./assets/collection3.png"/>
                                    <div className={styles.enhanceDecisionMakingWith}>Enhance decision-making with
                                        precision-driven AI tools for data-backed collection processes.
                                    </div>
                                </div>
                            </div>

                                                <div className={styles.frameGroup}>
                                                    <div className={styles.groupParent}>
                                                        <div className={styles.frameContainer}>
                                                            {/* <div className={styles.rectangleWrapper}>
                                                            <div className={styles.frameChild} />
                                                        </div> */}
                                                            {/* <img className={styles.groupChild} alt="" src="Group 41.svg" />
                                        						<div className={styles.johnCarter}>John Carter</div>
                                        						<div className={styles.fullName}>Full Name*</div> */}
                                                            <label
                                                                style={{
                                                                    fontWeight: "500",
                                                                    marginBottom: "10px",
                                                                    display: "block",
                                                                    color: "#170f49",
                                                                    fontSize: "18px",
                                                                }}
                                                            >
                                                                Full Name*
                                                            </label>

                                                            <div style={{position: "relative", width: "80%"}}>
                                                                <input
                                                                    value={fullName}
                                                                    onChange={(e) => setFullName(e.target.value)}
                                                                    placeholder="John Carter"
                                                                    style={{
                                                                        width: "98%",
                                                                        paddingLeft: "10px",
                                                                        paddingRight: "40px", // space for the image
                                                                        height: "50px",
                                                                        borderRadius: "10px",
                                                                        zIndex: 1000,
                                                                        fontSize: "16px",
                                                                        color: "black",
                                                                        border: "1px solid #ccc",
                                                                        outline: "none",
                                                                    }}
                                                                />

                                                                <img
                                                                    src="./assets/usericon.svg"
                                                                    alt="User Icon"
                                                                    style={{
                                                                        position: "absolute",
                                                                        right: "-20px",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                        height: "20px",
                                                                        width: "24px",
                                                                        pointerEvents: "none", // prevents image from blocking input clicks
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                        {/* <img className={styles.groupChild} alt="" src="Group 41.svg" /> */}
                                                    </div>
                                                    {/* <div className={styles.groupWrapper}>
                                                    <div className={styles.rectangleParent}>
                                                        <div className={styles.groupItem} />
                                                        <img className={styles.groupIcon} alt="" src="Group.svg" />
                                                        <div className={styles.johnCarter}>(123) 456 - 7890</div>
                                                        <div className={styles.fullName}>Phone Number*</div>
                                                    </div>
                                                </div> */}
                                                    <label style={{
                                                        fontWeight: "500",
                                                        marginBottom: "1px",
                                                        display: "block",
                                                        color: "#170f49",
                                                        fontSize: "18px",
                                                        marginTop: "20px"
                                                    }}>
                                                        Phone Number*
                                                    </label>

                                                    <div style={{position: "relative", width: "95%"}}>
                                                        <input
                                                            value={phoneno}
                                                            onChange={(e) => setPhoneno(e.target.value)}
                                                            placeholder="9876543210"
                                                            style={{
                                                                width: "98%", // full width of parent container
                                                                paddingLeft: "10px",
                                                                paddingRight: "40px", // space for the icon
                                                                height: "50px",
                                                                borderRadius: "10px",
                                                                marginTop: "-30px",
                                                                fontSize: "16px",
                                                                color: "black",
                                                                border: "1px solid #ccc",
                                                                outline: "none",
                                                                boxSizing: "border-box"
                                                            }}
                                                        />

                                                        <img
                                                            src="./assets/phoneno.svg"
                                                            alt="User Icon"
                                                            style={{
                                                                position: "absolute",
                                                                right: "30px",
                                                                top: "30%",
                                                                transform: "translateY(-50%)",
                                                                height: "22px",
                                                                width: "24px",
                                                                pointerEvents: "none"
                                                            }}
                                                        />
                                                    </div>

                                                    {/* <div className={styles.groupWrapper}>
                                                    <div className={styles.rectangleParent}>
                                                        <div className={styles.groupItem} />
                                                        <img className={styles.groupIcon1} alt="" src="Group.svg" />
                                                        <div className={styles.johnCarter}>Email address</div>
                                                        <div className={styles.fullName}>Email Address*</div>
                                                    </div>
                                                </div>
                                            </div> */}
                                                    <label style={{
                                                        fontWeight: "500",
                                                        marginBottom: "10px",
                                                        display: "block",
                                                        color: "#170f49",
                                                        fontSize: "18px",
                                                        marginTop: "2px"
                                                    }}>
                                                        Email Address*
                                                    </label>
                                                    <div style={{position: "relative", width: "95%"}}>
                                                        <input
                                                            value={emaiAddress}
                                                            onChange={(e) => setMailAddress(e.target.value)}
                                                            placeholder="Email Address"
                                                            style={{
                                                                width: "93%",
                                                                paddingLeft: "10px",
                                                                height: "50px",
                                                                borderRadius: "10px",
                                                                zIndex: 1000,
                                                                marginTop: "-30px",
                                                                fontSize: "16px",
                                                                color: "black",
                                                                border: "1px solid #ccc", // Light grey border
                                                                outline: "none",
                                                            }}
                                                        />
                                                        <img
                                                            src="./assets/email.svg"
                                                            alt="User Icon"
                                                            style={{
                                                                position: "absolute",
                                                                right: "30px",
                                                                top: "5%",
                                                                transform: "translateY(-50%)",
                                                                height: "24px",
                                                                width: "20px",
                                                                pointerEvents: "none", // prevents image from blocking input clicks
                                                            }}
                                                        />
                                                        <div className={styles.primaryBtn} onClick={handleSubmit}>
                                                        <div
                              className={styles.buttonText}
                              style={{
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px", // space between text and icon
                              }}
                            >
                              Submit
                              <img
                                src="./assets/rightarrow.svg" // update the path to your icon
                                alt="Submit Icon"
                                style={{
                                  height: "20px",
                                  width: "20px",
                                }}
                              />
                            </div>

                                                            <img className={styles.arrowRightIcon} alt="" src="./assets/arrow.png" />
                                                        </div>
                                                    </div>
                                                </div>
                        </div>

                    </>


                )}


            </div>
            {loading && (
                <div
                    className="loader-container"
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        position: 'fixed',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        zIndex: 9999,
                        width: '100vw',
                        height: '100vh',
                        backgroundColor: 'rgba(0, 0, 0, 0.5)'
                    }}
                >
                    {/* Show MoonLoader spinner when loading is true */}
                    <MoonLoader color="white" size={40} />
                </div>
            )}

        </center >

    );
};

export default ContactSales;
